import { useGameplayStore } from "../game/stores/useGameplayStore";
import { unifiedDataStore } from "../services/UnifiedDataStore";

/** The persisted thread default (spec D4); off when unreadable: she stays unobtrusive until asked. */
export async function threadDefault(): Promise<boolean> {
  try {
    return (await unifiedDataStore.getAriadne()).show_thread;
  } catch {
    return false;
  }
}

/** Show or hide her thread now, and remember it. She plays either way. */
export async function setThreadShown(on: boolean): Promise<void> {
  useGameplayStore.getState().setPathDisplayMode({ ai: on });
  try {
    await unifiedDataStore.setAriadneThreadDefault(on);
  } catch (error) {
    console.error("ariadne: could not save the thread default:", error);
  }
}
